import type { LucideIcon } from "lucide-react";

export function UsageSummaryMetric({
  label,
  value,
  icon: Icon,
}: {
  label: string;
  value: string;
  icon: LucideIcon;
}) {
  return (
    <div className="panel p-5">
      <div className="flex items-center gap-3 text-stone-500">
        <Icon size={17} />
        <span className="text-xs font-bold tracking-wider uppercase">
          {label}
        </span>
      </div>
      <div className="mt-3 text-3xl font-bold tracking-tight">{value}</div>
    </div>
  );
}
